import { hDeepClone } from '@/utils/helpers';
import ShButton from '@/components/Helpers/ShButton';
import ShPopconfirm from '@/components/Helpers/ShPopconfirm';

export default {
  name: 'WidgetsListItem',

  components: {
    ShPopconfirm,
    ShButton,
  },

  props: {
    widget: {
      type: Object,
      default: () => ({}),
    },
    canDuplicate: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      editableWidget: hDeepClone(this.widget),
      isWaitingForToggleOrDuplicateWidget: false,
    };
  },

  watch: {
    widget: {
      handler(newValue) {
        this.editableWidget = hDeepClone(newValue);
      },
      deep: true,
    },
  },
  computed: {
    user() {
      return this.$store.getters['authorization/user'];
    },
    numbersList() {
      return this.$store.getters['numbers/list'];
    },
    listOfNumberThatAreAssigned() {
      return this.numbersList.filter(number => !!number.assigned_to_agent_id);
    },
  },

  methods: {
    handleEditWidget() {
      this.$router.push({ name: 'WidgetDetails', params: { id: this.widget.id } });
    },
    async handleToggleWidgetActivity() {
      this.isWaitingForToggleOrDuplicateWidget = true;
      if (this.listOfNumberThatAreAssigned.length > 0 || this.editableWidget.is_active) {
        try {
          await this.$store.dispatch('widgets/toggleWidgetActivity', {
            id: this.widget.id,
            isActive: !this.editableWidget.is_active,
          });
          this.isWaitingForToggleOrDuplicateWidget = false;
          this.$set(this.editableWidget, 'is_active', !this.editableWidget.is_active);

          this.$notify.success({
            title: this.editableWidget.is_active ? 'Włączono widget' : 'Wyłączono widget',
            message: `Widget ${this.widget.name} został ${this.editableWidget.is_active ? 'włączony' : 'wyłączony'}`,
            customClass: 'callmeweb-notification',
          });
        } catch (e) {
          this.isWaitingForToggleOrDuplicateWidget = false;
        }
      } else {
        this.isWaitingForToggleOrDuplicateWidget = false;
        this.$EventBus.$emit('widget/TOGGLE_CONFIG_MODAL', { widgetId: this.widget.id, toggleNumberRequired: true });
      }
    },
    async handleDeleteWidget() {
      await this.$store.dispatch('widgets/delete', { id: this.widget.id });
      await this.$store.dispatch('widgets/getList');

      this.$notify.success({
        title: 'Usunięto widget',
        message: `Widget ${this.widget.name} został usunięty`,
        customClass: 'callmeweb-notification',
      });
    },
    async handleDuplicateWidget() {
      this.isWaitingForToggleOrDuplicateWidget = true;
      const newWidgetId = await this.$store.dispatch('widgets/duplicate', { widgetId: this.widget.id });
      this.isWaitingForToggleOrDuplicateWidget = false;
      this.$router.push({ name: 'WidgetDetails', params: { id: newWidgetId } });
    },
  },

};
